import React from "react";
import "./MfaStatusCard.scss";
import Card from "../Card";
import Skeleton from "../Skeleton/Skeleton";

const MfaStatusCard = ({ contact, loading }: any) => {
  if (loading) {
    return (
      <Card
        title="MFA"
        body={
          <div className="mfa-status-card">
            <div className="mfa-status-card__status">
              <Skeleton variant="text" width="30%" />
            </div>
          </div>
        }
      />
    );
  }

  return (
    <Card
      title="MFA"
      body={
        <div className="mfa-status-card">
          <div className="mfa-status-card__status">
            {contact.mfaEnabled ? "Enabled" : "Disabled"}
          </div>
        </div>
      }
    />
  );
};

export default MfaStatusCard;